import styled from 'styled-components'

export const StyledSettings = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;

    width: 100%;

    background: ${({ theme }) => theme.body.componentsWrapperBg};
    padding: 20px;
    border-radius: 16px;
`

export const StyledRow = styled.div<{ displayEnd?: boolean }>`
    display: flex;
    align-items: center;
    gap: 6px;

    justify-content: ${({ displayEnd }) => (displayEnd ? 'flex-end' : 'flex-start')};
`
